import { type UserProfile } from './api/schema/profileSchema';

const hasActiveSubscription = (profile: UserProfile): boolean =>
  Boolean(profile?.subscription?.hasActiveSubscription) && profile.type !== 'free' && profile.type !== 'promo';

// it's either verified or created via OAuth
const isEmailVerified = (profile: UserProfile): boolean =>
  profile.email_verified || (!profile.email_verified && !profile.is_password_set);

const isNewUser = (profile: UserProfile) => profile.devices.length === 0;

const isAllowedToTrial = (profile: UserProfile) => profile.state === 'new_account';

export { hasActiveSubscription, isEmailVerified, isNewUser, isAllowedToTrial };
